import { render, staticRenderFns } from "./ETabItem.vue?vue&type=template&id=2b15f287&scoped=true"
import script from "./ETabItem.vue?vue&type=script&lang=js"
export * from "./ETabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15f287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b15f287')) {
      api.createRecord('2b15f287', component.options)
    } else {
      api.reload('2b15f287', component.options)
    }
    module.hot.accept("./ETabItem.vue?vue&type=template&id=2b15f287&scoped=true", function () {
      api.rerender('2b15f287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ETabItem.vue"
export default component.exports